/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuRadioSelectList_itemSearch$ref = any;
export type SbSharedRefineMenuFilterItemType_itemSearch$ref = any;
export type SbSharedRefineMenuFilterItemType_itemSearch = {
    readonly " $fragmentRefs": SbSharedRefineMenuRadioSelectList_itemSearch$ref;
    readonly " $refType": SbSharedRefineMenuFilterItemType_itemSearch$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterItemType_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuRadioSelectList_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'a2775814b44c41ccb21661998e7c392e';
export default node;
